






























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Modify from './Service/Modify';
// import DoModify, { typeDoModify } from './Service/DoModify';
import Delete from './Service/Delete';
import manageForm from './form';

@Component({
  components: {},
})
export default class roleModify extends Vue {
  private loading: boolean = false;

  private manageForm: Object = manageForm;

  private form: any = {
    p3_account: {
      p3_ape_email: [],
      p3_ape_tel: [],
    },
    p5_role: {},
  };

  /**
   * getInfo 取得資料
   */
  public async getInfo() {
    const getter = await new Modify({
      p3_ant_id: this.$route.query.p3_ant_id,
    }).get();
    this.form = getter;
  }

  /** 刪除功能，可複選 */
  public async doDelete(item?: any) {
    const doDelete = (await new Delete(item).delete()) as any;
    if (doDelete.data.code === 0) {
      this.$router.push('/account/manage/lists');
    }
  }

  private mounted() {
    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('modify', () => {
      this.$router.push(
        `/account/manage/modify?p3_ant_id=${this.$route.query.p3_ant_id}`,
      );
    });

    this.getInfo();
  }
}
